import React from 'react'

import { FormSubmitErrorsProps } from '../../form/FormSubmitErrors'
import { TextFieldProps } from '../../form/TextField'
import FormikField from '../../form/FormikField'
import { SubmitButtonProps } from '../../form/SubmitButton'
import { FormikFormProps } from '../../form/FormikForm'
import { SelectProps } from '../../form/Select'
import { ActionButtonProps } from '../../ActionButton'

import * as SC from './styled'

export type AppointementFormValues = {
  firstName: string
  lastName: string
  email: string
  store: string
  date: string
  slot: string
}

export type AppointementFormProps = {
  className?: string
  formik: FormikFormProps<AppointementFormValues>
  fields: {
    firstName: TextFieldProps
    lastName: TextFieldProps
    email: TextFieldProps
    store: SelectProps
    date: SelectProps
    slot: SelectProps
  }
  submitErrors?: FormSubmitErrorsProps['errors']
  submitButton: SubmitButtonProps
  editMessageButton?: ActionButtonProps
}

const AppointementForm: React.FC<AppointementFormProps> = ({
  className,
  formik,
  fields,
  submitErrors,
  submitButton,
  editMessageButton,
}) => {
  return (
    <SC.Form {...formik} className={className}>
      <SC.Fields>
        <SC.HorizontalFields>
          <FormikField {...fields.firstName} Component={SC.TextField} />
          <FormikField {...fields.lastName} Component={SC.TextField} />
        </SC.HorizontalFields>
        <FormikField {...fields.email} Component={SC.TextField} />
        <FormikField {...fields.store} Component={SC.SelectField} />
        <SC.HorizontalFields>
          <FormikField {...fields.date} Component={SC.SelectField} />
          <FormikField {...fields.slot} Component={SC.SelectField} />
        </SC.HorizontalFields>
      </SC.Fields>
      {submitErrors && <SC.SubmitErrors errors={submitErrors} />}
      <SC.Buttons>
        {editMessageButton && <SC.EditButton {...editMessageButton} />}
        <SC.Submit {...submitButton} />
      </SC.Buttons>
    </SC.Form>
  )
}

export default AppointementForm
